'use strict';

goog.provide("Ntry.STATIC");

(function(s){
    /* component type */
    s.POSITION = 0;
    s.MOTION = 1;
    s.ANIMATION = 2;
    s.BITMAP = 3;
    s.TILE = 4;
    s.GRID = 5;
    s.MESSAGE_HANDLER = 6;
    s.SCRIPT_CONTAINER = 7;
    s.RUNNING_SCRIPT = 8;
    s.RESTORE = 9;
    s.SPRITE = 10;
    s.UNIT = 11;
    s.ITEM = 12;
    s.SPACE_SHIP = 13;
    s.RADAR = 14;
    s.ANIMATE = 15;
    s.SCROLL = 16;
    s.CODE = 17;

    /* tile type */
    s.ROAD = 0;
    s.WALL = 1;
    s.OBSTACLE_ELECTRIC = 2;
    s.OBSTACLE_BEE = 3;
    s.OBSTACLE_BANANA = 4;
    s.OBSTACLE_METEO = 5;
    s.GOAL = 6;
    s.OBSTACLE_SIGN = 7;
    s.OBSTACLE_NOTICE = 8;
    s.FLOWER = 9;
    s.OBSTACLE_SLOW = 10;
    s.OBSTACLE_REPAIR = 11;

    /* item type */
    s.GOAL_ITEM = 0;
    s.AI_GOAL = 1;
    s.AI_METEO = 2;
    s.AI_ITEM = 3;
    s.JR_ITEM = 4;
    s.AI_WALL = 5;

    s.CONSUMABLE_ITEMS = [
        s.GOAL_ITEM,
        s.AI_ITEM,
        s.JR_ITEM
    ];

    s.RESTORE_COMPONENT_TYPES = [
        s.POSITION
    ];

    s.RESTORE_BLACK_LIST = [
        s.RUNNING_SCRIPT,
        s.SCRIPT_CONTAINER,
        s.RESTORE,
        s.CODE
    ];

    s.RESTORE_TRUE = true;
    s.RESTORE_FALSE = false;

    /* direction */
    s.NORTH = 1;
    s.EAST = 2;
    s.SOUTH = 3;
    s.WEST = 4;
    s.RIGHT = 5;
    s.LEFT = 6;
    s.DIRECTION_MAP = [
        s.WEST,
        s.NORTH,
        s.EAST,
        s.SOUTH,
        s.WEST,
        s.NORTH,
        s.EAST
    ];

    /* unit action type */
    s.STAND = 1;
    s.WALK = 2;
    s.JUMP = 3;
    s.TURN_RIGHT = 4;
    s.TURN_LEFT = 5;
    s.SIMOOROOK = 6;
    s.WALL_CRASH = 7;
    s.BEE_ATTACK = 8;
    s.ELECTRIC_SHOCK = 9;
    s.SLIP = 10;
    s.COMPLETE = 11;
    s.STOP = 12;
    s.SEQUENCE_SIMOOROOK = 13;
    s.GET_ITEM = 14;
    s.WITHOUT_ITEM_SUCCESS =15;
    s.HALF_ROTATION = 16;
    s.GO_SLOW = 17;
    s.GO_SLOW_CRASH = 18;
    s.ATTACK_LUPIN = 19;

    /* space ship action type */
    s.COLLISION = 13;
    s.LOST = 14;

    s.ESSENTIAL_REQUIRED = 19;
    s.OVER_LIMITED_BLOCK = 20;

    /* animate type */
    s.ROTATE = 1;
    s.ROTATE_TO = 2;
    s.ROTATE_INFINITE = 3;
    s.FADE_OUT = 4;
    s.POP_OUT = 5;
    s.VIBRATE = 6;

    s.getAllBlocks = function() {
        return [
            "maze_step_start",
            "maze_step_jump",
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_for",
            "maze_step_for_true_1",
            "maze_step_for_true_2",
            "maze_step_if_1",
            "maze_step_if_2",
            "maze_step_if_3",
            "maze_repeat_until_1",
            "maze_repeat_until_2",
            "maze_define_function",
            "maze_call_function"
            /*
            "maze_step_unstart",
            "maze_step_unjump",
            "maze_step_move_unstep",
            "maze_step_unrotate",
            "maze_step_unfor",
            "maze_step_unfor_true_1",
            "maze_step_unfor_true_2",
            "maze_step_unif_1",
            "maze_step_unif_2",
            "maze_step_unif_3",
            "maze_repeat_ununtil_1",
            "maze_repeat_ununtil_2",
            "maze_define_unfunction",
            "maze_call_unfunction"
            */
        ];
    };

    s.blockInfo = {
        "maze_step_start": {
            "xml": "<block type='maze_step_start'></block>"
        },
        "maze_step_jump": {
            "xml": "<block type='maze_step_jump'></block>"
        },
        "maze_step_move_step": {
            "xml": "<block type='maze_step_move_step'></block>"
        },
        "maze_step_rotate": {
            "xml": "<block type='maze_step_rotate'></block>",
            "xmls": [
                "<block type='maze_step_rotate'><field name='VALUE'>LEFT</field></block>",
                "<block type='maze_step_rotate'><field name='VALUE'>RIGHT</field></block>"
            ]
        },
         "maze_step_for": {
            "xml": "<block type='maze_step_for'><field name='VALUE'>2</field></block>"
        },
         "maze_step_ebs_for": {
            "xml": "<block type='maze_step_for'><field name='VALUE'>1</field></block>"
        },
        "maze_step_if_1": {
            "xml": "<block type='maze_step_if_1'></block>"
        },
        "maze_step_if_2": {
            "xml": "<block type='maze_step_if_2'></block>"
        },
        "maze_step_if_3": {
            "xml": "<block type='maze_step_if_3'></block>"
        },
        "maze_step_for_true_1": {
            "xml": "<block type='maze_step_for_true_1'></block>"
        },
        "maze_step_for_true_2": {
            "xml": "<block type='maze_step_for_true_2'></block>"
        },
        "maze_repeat_until_1": {
            "xml": "<block type='maze_repeat_until_1'></block>"
        },
        "maze_repeat_until_2": {
            "xml": "<block type='maze_repeat_until_2'></block>"
        },
        "maze_define_function": {
            "xml": "<block type='maze_define_function'></block>"
        },
        "maze_call_function": {
            "xml": "<block type='maze_call_function'></block>"
        },
         "maze_step_unstart": {
            "xml": "<block type='maze_step_unstart'></block>"
        },
        "maze_step_unjump": {
            "xml": "<block type='maze_step_unjump'></block>"
        },
        "maze_step_move_unstep": {
            "xml": "<block type='maze_step_move_unstep'></block>"
        },
        "maze_step_unrotate": {
            "xml": "<block type='maze_step_unrotate'></block>"
        },
         "maze_step_unfor": {
            "xml": "<block type='maze_step_unfor'><field name='VALUE'>2</field></block>"
        },
         "maze_step_unfor_true_1": {
            "xml": "<block type='maze_step_unfor_true_1'></block>"
        },
        "maze_step_unfor_true_2": {
            "xml": "<block type='maze_step_unfor_true_2'></block>"
        },
        "maze_step_unif": {
            "xml": "<block type='maze_step_unif'><value name='BOOL'><block type='True'></block></value> </block>"
        },
        "maze_step_unif_1": {
            "xml": "<block type='maze_step_unif_1'></block>"
        },
        "maze_step_unif_2": {
            "xml": "<block type='maze_step_unif_2'></block>"
        },
        "maze_step_unif_3": {
            "xml": "<block type='maze_step_unif_3'></block>"
        },
        "maze_repeat_ununtil_1": {
            "xml": "<block type='maze_repeat_ununtil_1'></block>"
        },
        "maze_repeat_ununtil_2": {
            "xml": "<block type='maze_repeat_ununtil_2'></block>"
        },
        "maze_define_unfunction": {
            "xml": "<block type='maze_define_unfunction'></block>"
        },
        "maze_call_unfunction": {
            "xml": "<block type='maze_call_unfunction'></block>"
        },
        "ai_start": {
            "xml": "<block type='ai_start'></block>"
        },
        "ai_move_right": {
            "xml": "<block type='ai_move_right'></block>"
        },
        "ai_move_up": {
            "xml": "<block type='ai_move_up'></block>"
        },
        "ai_move_down": {
            "xml": "<block type='ai_move_down'></block>"
        },
        "ai_if_else_1": {
            "xml": "<block type='ai_if_else_1'></block>"
        },
        "ai_if_else_2": {
            "xml": "<block type='ai_if_else_2'><value name='BOOL'><block type='True'></block></value></block>"
        },
        "ai_boolean_distance": {
            "xml": "<block type='ai_boolean_distance' class='output ai_boolean_distance' inline='true'><field name='DIRECTION'>RIGHT</field><field name='OPERATOR'>BIGGER</field><value name='DATA'><block type='number' class='output number'><field name='NUM'>1</field></block></value></block>"
        },
        "ai_distance_value": {
            "xml": "<block type='ai_distance_value'><field name='DIRECTION'>RIGHT</field></block>"
        },
        "ai_boolean_object": {
            "xml": "<block type='ai_boolean_object'><field name='DIRECTION'>RIGHT</field></block>"
        },
        "ai_use_item": {
            "xml": "<block type='ai_use_item'></block>"
        },
        "ai_repeat_until_reach": {
            "xml": "<block type='ai_repeat_until_reach'></block>"
        },
        "ai_boolean_and": {
            "xml": "<block type='ai_boolean_and'><value name='LEFTHAND'><block type='True'></block></value><value name='RIGHTHAND'><block type='True'></block></value></block>"
        },
        "number": {
            "xml": "<block type='number'></block>"
        },
        "maze_step_if_4" : {
             "xml": "<block type='maze_step_if_4'></block>"
        },
        "ebs2015_maze_move_step": {
            "xml": "<block type='ebs2015_maze_move_step'></block>"
        },
        "ebs2015_maze_while_true_1": {
            "xml": "<block type='ebs2015_maze_while_true_1'></block>"
        },
        "ebs2015_maze_repeat_until_1": {
            "xml": "<block type='ebs2015_maze_repeat_until_1'></block>"
        },
        "ebs2015_maze_if_wall": {
            "xml": "<block type='ebs2015_maze_if_wall'></block>"
        },
        "ebs2015_maze_if_else_wall": {
            "xml": "<block type='ebs2015_maze_if_else_wall'></block>"
        },
        "ebs2015_maze_if_else_notice": {
            "xml": "<block type='ebs2015_maze_if_else_notice'></block>"
        }
    };

    /* Ntry engine status */
    s.ENGINE_STOP = 0;
    s.ENGINE_RUN = 1;
    s.ENGINE_END = 2;
    
    s.COMMAND_MOVE = {
        command: 'move();',
        description: Lang.Menus.maze_command_move_desc,
        images: ['move01','move02'],
    };

    s.COMMAND_JUMP = {
        command: 'jump();',
        description: Lang.Menus.maze_command_jump_desc,
        images: ['jump01','jump02'],
    };

    s.COMMAND_JUMP_ELEC = {
        command: 'jump();',
        description: Lang.Menus.maze_command_jump_desc_elec,
        images: ['jump01','jump02'],
    };

    s.COMMAND_RIGHT = {
        command: 'right();',
        description: Lang.Menus.maze_command_right_desc,
        images: ['right01','right02']
    };

    s.COMMAND_LEFT = {
        command: 'left();',
        description: Lang.Menus.maze_command_left_desc,
        images: ['left01','left02']
    };

    s.COMMAND_FOR = {
        command: 'for (var i = 0; i < <span class="textShadow">1</span>; i++){</br>}',
        description: Lang.Menus.maze_command_for_desc,
        images: ['for01','for02']
    };

    s.COMMAND_WHILE = {
        command: 'while (true) {</br>}',
        description: Lang.Menus.maze_command_while_desc,
        images: ['while01','while02'],
    };

    s.COMMAND_IF = {
        command: 'if (front == \"wall\") {</br>}',
        description: Lang.Menus.maze_command_if1_desc,
        images: ['if01','if02']
    };

    s.COMMAND_SLOW = {
        command: 'move_slowly();',
        description: Lang.Menus.maze_command_slow_desc,
        images: ['slow01','slow02']
    };

    s.COMMAND_AI_MOVE = {
        command: 'move();',
        description: '엔트리봇을 한 칸 앞으로 이동시킵니다.',
        images: ['ai_move01','ai_move02']
    };

    s.COMMAND_AI_UP = {
        command: 'up();',
        description: '엔트리봇을 한 칸 위로 이동시킵니다.',
        images: ['ai_up01','ai_up02']
    };

    s.COMMAND_AI_DOWN = {
        command: 'down();',
        description: '엔트리봇을 한 칸 아래로 이동시킵니다.',
        images: ['ai_down01','ai_down02']
    };

    s.COMMAND_AI_WHILE = {
        command: 'while (true) {}',
        description: '미션이 끝날 때까지 괄호({ })안에 있는 명령을 계속 반복해서 실행합니다.',
        images: ['ai_while01','ai_while02']
    };

    s.COMMAND_AI_IF_ELSE = {
        command: 'if (radar_right > 1) {} else {}',
        description: '조건(앞 레이더 값이 1보다 클때)이 발생했을 때, if 아래의 괄호({})안에 있는 명령을 실행하고, 그렇지 않은 경우 else 아래의 괄호 안에 있는 명령을 실행합니다.',
        images: ['ai_if_else01','ai_if_else02']
    };

    s.COMMAND_AI_ITEM = {
        command: 'use_item();',
        description: '앞에 있는 모든 돌들을 없앱니다. 단, 아이템을 획득했을 경우에만 사용할 수 있습니다.',
        images: ['ai_item01','ai_item02']
    };

    s.COMMAND_AI_TYPE_1 = {
        title: Lang.Menus.maze_command_title,
        content : [
            Ntry.STATIC.COMMAND_AI_MOVE,
            Ntry.STATIC.COMMAND_AI_UP,
            Ntry.STATIC.COMMAND_AI_DOWN
        ]
    };

    s.COMMAND_AI_TYPE_2 = {
        title: Lang.Menus.maze_command_title,
        content : [
            Ntry.STATIC.COMMAND_AI_MOVE,
            Ntry.STATIC.COMMAND_AI_UP,
            Ntry.STATIC.COMMAND_AI_DOWN,
            Ntry.STATIC.COMMAND_AI_WHILE
        ]
    };

    s.COMMAND_AI_TYPE_3 = {
        title: Lang.Menus.maze_command_title,
        content : [
            Ntry.STATIC.COMMAND_AI_MOVE,
            Ntry.STATIC.COMMAND_AI_UP,
            Ntry.STATIC.COMMAND_AI_DOWN,
            Ntry.STATIC.COMMAND_AI_WHILE,
            Ntry.STATIC.COMMAND_AI_IF_ELSE
        ]
    };

    s.COMMAND_AI_TYPE_4 = {
        title: Lang.Menus.maze_command_title,
        content : [
            Ntry.STATIC.COMMAND_AI_MOVE,
            Ntry.STATIC.COMMAND_AI_UP,
            Ntry.STATIC.COMMAND_AI_DOWN,
            Ntry.STATIC.COMMAND_AI_WHILE,
            Ntry.STATIC.COMMAND_AI_IF_ELSE,
            Ntry.STATIC.COMMAND_AI_ITEM
        ]
    };

})(Ntry.STATIC);
